import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	selectProgress: ({ plantCd, shopCd }) =>
		client.get(`${BASE_URL}/customizingBoard/v1/plants/${plantCd}/shops/${shopCd}`).then(res => res && res.data)
};
